import { render, staticRenderFns } from "./PacoteKitGrade.vue?vue&type=template&id=8711bb0e&scoped=true"
import script from "./PacoteKitGrade.vue?vue&type=script&lang=js"
export * from "./PacoteKitGrade.vue?vue&type=script&lang=js"
import style0 from "./PacoteKitGrade.vue?vue&type=style&index=0&id=8711bb0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8711bb0e",
  null
  
)

export default component.exports